import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import AddManualModal from './AddManualModal';
import ManualListTable from './ManualListTable';
import { Button, Tooltip } from 'flowbite-react';
import { HiPlus } from 'react-icons/hi';
import { SubCategoryManual } from '../../Models/SubCategoryManual';
import EquipmentApi from '../../Api/EquipmentApi';

export default function ManualList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [manualListData, setmanualListData] = useState<SubCategoryManual[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [show, setshow] = useState<boolean>(false);
  const [selectedManual, setselectedManual] =
    useState<SubCategoryManual | null>(null);

  const getManuals = useCallback(() => {
    if (userModel) {
      setIsLoading(true);
      return EquipmentApi.getSubCategoryManualList()
        .then((res) => {
          setmanualListData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          toast.error('Error');
          setIsLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    getManuals();
  }, [getManuals]);

  function deleteManual(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );
    if (shouldRemove) {
      return EquipmentApi.deleteSubCategoryManual(id)
        .then((res) => {
          toast.success('Success');
          getManuals();
          setIsLoading(false);
        })
        .catch((err) => {
          toast.error('Error');
          setIsLoading(false);
        });
    }
  }

  const handleSetManualClick = (manual: SubCategoryManual) => {
    setselectedManual(manual);
    setshow(true);
  };

  const handleAddManualClick = () => {
    setselectedManual(null);
    setshow(true);
  };

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Manuals</div>
              </h1>
            </div>
            {checkAccess() && (
              <div className=''>
                <Tooltip content={`Add Manual`}>
                  <Button onClick={handleAddManualClick} className='buttonMain'>
                    <HiPlus size={20} />
                  </Button>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
          {isLoading && <Loader />}
          <ManualListTable
            data={manualListData}
            deleteManual={deleteManual}
            setselectedManual={handleSetManualClick}
          />
        </div>
      </div>
      <AddManualModal
        show={show}
        setShow={setshow}
        getManuals={getManuals}
        selectedManual={selectedManual}
      />
    </>
  );
}
